import { render, staticRenderFns } from "./BusinessEditTabInformation.vue?vue&type=template&id=00d87f6c&"
import script from "./BusinessEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./BusinessEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports